import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { LedgerSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/wage-ledger/_layout/ledger/')({
  validateSearch: zodValidator(LedgerSearchSchema)
});